import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';

const Edit_contract = (props) => {
  document.title = "Edit Contract";
  const history = useHistory();
  const { postRequest } = useRequests();

  const [AlertData, setAlertData] = useState({ variant: '', message: '' });
  const [selectedLang, setSelectedLang] = useState("eng");
  const [langData, setLangData] = useState({
    eng: { name: "" },
    es: { name: "" }
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData({ variant: '', message: '' });
    }, 5000);
  };

  const validationSchema = Yup.object({
    enName: Yup.string().required("Contract Type is required"),
    // esName: Yup.string().required("Contract Type is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      enName: langData.eng.type,
      // esName: langData.es.type,
    },
    validationSchema,
    onSubmit: async () => {
      try {
        const payload = [
          { lang: localStorage.getItem("I18N_LANGUAGE"), type: langData.eng.type },
          // { lang: "es", type: langData.es.type }
        ];

        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          con_id: atob(props.match.params.id),
          data: payload
        });

        const res = await postRequest('update-contract', jsonpar);
        if (res && res.code === 200) {
          history.push({
            pathname: '/contract_management',
            state: { code: 200, status: 'success', message: res.message }
          });
        } else {
          setAlertData({ variant: 'error', message: res.message });
        }
        resetAlertData();
        submit1.disabled = false;
        submit1.textContent = 'Update';
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const handleLangChange = (lang) => setSelectedLang(lang);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    const currentLang = selectedLang;
    setLangData((prev) => ({
      ...prev,
      [currentLang]: { ...prev[currentLang], [name]: value }
    }));
    formik.setFieldValue(
      `${currentLang}${name.charAt(0).toUpperCase() + name.slice(1)}`,
      value
    );
  };

  const handleLoadGetContractInfo = async () => {
    const jsonpar = JSON.stringify({
      con_id: atob(props.match.params.id)
    });
    const res = await postRequest('get-contract-info', jsonpar);

    if (res && res.code === 200 && Array.isArray(res.data)) {
      let updatedData = { eng: { type: ""} };

      updatedData.eng = { type: res.data[0].type }

      // res.data[1].forEach(item => {
      //   if (item.lang === "es") updatedData.es = { type: item.type};
      // });

      setLangData(updatedData);
      formik.setValues({
        enName: updatedData.eng.name,
        // esName: updatedData.es.name,
      });
    } else {
      setAlertData({ variant: 'error', message: res.message });
      resetAlertData();
    }
  };

  useEffect(() => {
    if (!props.match.params.id) {
      history.push({
        pathname: '/contract_management',
        state: { code: 401, status: 'error', message: 'ID not found! Please provide a valid ID.' }
      });
    } else {
      handleLoadGetContractInfo();
    }
  }, []);

  return (
    <React.Fragment>
      {AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Edit Contract")} />
          <Card>
            <CardBody>
              {/* <Row>
                <Col md={4}>
                  <Label className="form-label">Select Language:</Label>
                  <Input
                    type="select"
                    value={selectedLang}
                    onChange={(e) => handleLangChange(e.target.value)}
                  >
                    <option value="eng">English</option>
                    <option value="es">Spanish</option>
                  </Input>
                </Col>
              </Row> */}
              <Row className="mt-3">
                <Col md={6}>
                  <div className="mb-3">
                    <Label className="form-label">
                      Contract Type :
                    </Label>
                    <Input
                      name="type"
                      type="text"
                      placeholder={`Enter Contract Type (${localStorage.getItem("I18N_LANGUAGE").toUpperCase()})`}
                      value={langData[selectedLang].type}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched[`${selectedLang}Name`] &&
                        formik.errors[`${selectedLang}Name`]
                      }
                    />
                    {formik.touched[`${selectedLang}Name`] &&
                      formik.errors[`${selectedLang}Name`] && (
                        <FormFeedback type="invalid">
                          {formik.errors[`${selectedLang}Name`]}
                        </FormFeedback>
                      )}
                  </div>
                </Col>

              </Row>
              <div className="text-left mt-2">
                <button
                  type="button"
                  id="submit1"
                  onClick={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                  }}
                  className="btn btn-primary me-2"
                >
                  Update
                </button>
                <Link to="/contract_management" className="btn btn-light me-2">Cancel</Link>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Edit_contract);
